import { Component, OnInit, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    @Output() toggleMobileMenu = new EventEmitter<void>();

    private toggleButton: any;
    private sidebarVisible: boolean;
    linkList = [
        {
            href: '/home',
            iconClass: 'now-ui-icons files_paper',
            text: 'Home'
        },
        {
            href: '/meteo',
            iconClass: 'now-ui-icons files_paper',
            text: 'Meteo'
        },
        {
            href: '/tempo-reale',
            iconClass: 'now-ui-icons arrows-1_share-66',
            text: 'Tempo Reale'
        },
        {
            href: '/dati',
            iconClass: 'now-ui-icons arrows-1_share-66',
            text: 'Dati'
        },
        {
            href: '/documenti',
            iconClass: 'now-ui-icons arrows-1_share-66',
            text: 'Documenti'
        },
        {
            href: '/ict-radio',
            iconClass: 'now-ui-icons arrows-1_share-66',
            text: 'ICT'
        },
        {
            href: '/news',
            iconClass: 'now-ui-icons arrows-1_share-66',
            text: 'News'
        },
        {
            href: '/chi-siamo',
            iconClass: 'now-ui-icons arrows-1_cloud-download-93',
            text: 'Chi siamo'
        },
        // {
        //     href: '',
        //     iconClass: 'now-ui-icons arrows-1_share-66',
        //     text: 'Contatti'
        // },
    ];

    isLogoBarHidden: boolean = false;
    currentRoute: string = '';

    constructor(
        public location: Location,
        private element: ElementRef,
        public router: Router,
    ) {
        this.sidebarVisible = false;
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const scrollThreshold = 100;
        const logoBar = document.getElementById('logo-bar');

        if (window.scrollY > scrollThreshold && logoBar && !logoBar.classList.contains('hidden')) {
            logoBar.classList.add('hidden');
            logoBar.classList.add('bg-primary');
            logoBar.classList.remove('filter-nav');
        } else if (window.scrollY <= scrollThreshold && logoBar && logoBar.classList.contains('hidden')) {
            logoBar.classList.remove('hidden');
            logoBar.classList.remove('bg-primary');
            logoBar.classList.add('filter-nav');
        }
    }

    ngOnInit() {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        this.router.events.subscribe(() => {
            this.updateCurrentRoute();
        });
        this.updateCurrentRoute();
    }

    updateCurrentRoute() {
        const path = this.router.url.split('/')[1];
        this.currentRoute = `/${path}`;
    }

    openMobileNavbar() {
        this.toggleMobileMenu.emit();
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementsByTagName('html')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        html.classList.add('nav-open');

        this.sidebarVisible = true;
    };

    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        // console.log(html);
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
    };

    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };

    routeTo(path: any) {
        this.router.navigate([path]);
    }

    handleLinkClick(event: MouseEvent, element: any): void {
        // Controlla se il clic è stato con CTRL, Command (su Mac), o clic centrale
        if (event.ctrlKey || event.metaKey || event.button === 1) {
            // Permetti al comportamento predefinito di aprire il link in una nuova scheda
            return;
        }

        // Previeni il comportamento predefinito per clic normali
        event.preventDefault();

        // Usa il router di Angular per navigare
        this.routeTo(element.href);
    }

    onSearch(event: KeyboardEvent) {
        const inputElement = event.target as HTMLInputElement;
        const searchTerm = inputElement.value.trim();

        if (searchTerm) {
            this.router.navigate(['/ricerca'], { queryParams: { find: searchTerm } });
        }
    }

    openToTouch(){
        document.getElementById('searchbar').classList.toggle('search-open-touch');
    }


}
